<template>
  <div id="searchPage" class="search">
    <error-boundary :stopPropagation="false">
      <nav
        id="navbar-scroll"
        class="navbar navbar-light bg-light fixed-top fixed-top-2 p-1 border border-secondary"
      >
        <ul class="nav nav-pills">
          <li class="nav-item">
            <a
              class="nav-link"
              data-target-sec="helpSection"
              @click="scrollTo('helpSection')"
              >Help</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-target-sec="searchDesc"
              @click="scrollTo('searchDesc')"
              >Query information</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-target-sec="analysisSection"
              @click="scrollTo('analysisSection')"
              >Analysis cart</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-target-sec="resultsSection"
              @click="scrollTo('resultsSection')"
              >Results table</a
            >
          </li>
        </ul>
        <button
          type="button"
          class="btn btn-info btn-xl ml-2"
          v-on:click="runDemo()"
          :disabled="hits.length === 0 && stepsCompleted < 1"
        >
          <span v-if="$parent.isDemoRunning">Continue</span>
          <span v-else>Take a</span> tour
        </button>
      </nav>

      <div id="errors" class="row">
        <div v-for="alert in alerts" :key="alert.id" class="col col-12">
          <div role="alert" class="alert" :class="'alert-' + alert.type">
            {{ alert.msg }}
            <button
              type="button"
              class="close"
              v-on:click="closeAlert(alert)"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
      <SearchResultsHelp id="helpSection"></SearchResultsHelp>
      <!-- Input query info-->
      <div class="row mt-3" id="searchDesc">
        <div class="col col-sm-5">
          <h1>Search results for</h1>
          <h5>{{ targetSequence.title }}</h5>
          <h5>Sequence length: <strong>{{ seq.length }}</strong></h5>
          <h5>Matches in database: <strong>{{ hits.length }}</strong></h5>
        </div>
        <div class="col col-sm-7">
          <div class="card">
            <h5 class="card-header m-0 p-2">Query sequence</h5>
            <div class="card-body p-1 bg-light">
              {{ targetSequence.sequence }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="jumbotron jumbotron-fluid"
        v-if="hits.length === 0 && stepsCompleted < 1"
      >
        <div class="container">
          <h1 class="display-4">Please wait...</h1>
          <div class="progress">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated bg-info"
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width: 100%"
            ></div>
          </div>
        </div>
      </div>
      <div v-else>
        <AnalysisCart
          id="analysisSection"
          :targetSequence="targetSequence"
          :session="targetSequence.sessionId"
        ></AnalysisCart>
        <ResultsTable
          id="resultsSection"
          :hits="targetSequence.hits"
        ></ResultsTable>
      </div>
      <ModellerKeyPrompt></ModellerKeyPrompt>
    </error-boundary>
  </div>
</template>

<script>
import introJs from "intro.js";
// import { eventBus } from "../main";
export default {
  name: "Search",
  components: {
    AnalysisCart: () => import("../components/AnalysisCart"),
    ErrorBoundary: () => import("../components/ErrorBoundary"),
    ResultsTable: () => import("../components/ResultsTable"),
    SearchResultsHelp: () => import("../components/SearchResultsHelp"),
    ModellerKeyPrompt: () => import("../components/ModellerKeyPrompt")
  },
  data: function () {
    return {
      alerts: [],
      alertsCount: 0,
      hits: [
        {
          masterID: "",
          score: "",
          ident: "",
          rmsd: "",
          aliLen: "",
          size: "",
          masterDbID: "",
          clusterDbId: "",
          representatives: [],
        },
      ],
      targetSequence: {},
      initialSelectionLimit: 5,
      stepsCompleted: 0,
      seq: "", // just the sequence without the header
    };
  },
  mounted() {
    this.targetSequence = this.$parent.lastQuery;
    const idx = this.targetSequence.sequence.indexOf("\n");
    this.seq = this.targetSequence.sequence.substring(idx).trim();

    this.$dataService.targetSequence = this.targetSequence;

    if (this.targetSequence.needSearch) {
      this.hits = [];
      const self = this;
      window.jQuery(document).ajaxStop(function () {
        if (!self.targetSequence.needSearch) return;
        // preselect
        self.selectInitial(self.initialSelectionLimit);
        self.stepsCompleted = 5; // need to get rid of this

        self.targetSequence.needSearch = false;
        self.targetSequence.hits = self.hits;
      });
      this.runSearch();
    } else {
      this.hits = this.targetSequence.hits;
    }

    const scrollSpy = function () {
      // has to be in same order as on page top to bottom
      const sections = [
        "helpSection",
        "searchDesc",
        "analysisSection",
        "resultsSection",
      ];
      let current;

      const scrollShift = 120; // approx top of the help section element
      const scrollTop = window.jQuery(window).scrollTop();

      sections.forEach((s) => {
        if (
          window.jQuery("#" + s) &&
          window.jQuery("#" + s).offset() &&
          window.jQuery("#" + s).offset().top <= scrollTop + scrollShift
        ) {
          current = s;
        }
      });

      window.jQuery("a[data-target-sec='" + current + "']").addClass("active");
      window
        .jQuery("nav a")
        .not("a[data-target-sec='" + current + "']")
        .removeClass("active");
    };

    window.jQuery(document).ready(function () {
      scrollSpy();
    });

    window.jQuery(window).scroll(function () {
      scrollSpy();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$parent.storeLastQuery();
    next();
  },
  methods: {
    log: function (msg) {
      console.log(msg);
    },
    scrollTo(id) {
      window.jQuery("body, html").animate(
        {
          scrollTop: window.jQuery("#" + id).offset().top - 95,
        },
        300
      );
    },
    addAlert: function (type, msg) {
      this.alerts.push({ type: type, msg: msg, id: this.alertsCount++ });
    },
    closeAlert: function (alert) {
      this.alerts = this.alerts.filter((a) => a !== alert);
    },
    splitPDB: function (pdbid) {
      const idx = pdbid.indexOf("_");

      let parts = [];
      if (idx > 0) parts = pdbid.split("_");
      else {
        parts[0] = pdbid.substring(0, 4);
        parts[1] = pdbid.substring(4);
      }
      return parts;
    },
    runSearch: function () {
      this.log("Starting search");
      this.sequenceToPDB(this.seq);
    },

    /// search utils
    /**
     * Submit sequence to PDBflex
     */
    sequenceToPDB(seq) {
      if (!window.jQuery) {
        this.log("No jquery");
        return;
      }

      this.log("sequenceToPDB: " + seq);
      const self = this;
      const data = {
        sequence: seq,
      };

      window.jQuery.ajax({
        type: "POST",
        url: this.$dataService.PDBFLEX + "php/sequenceToPDB.php",
        data: data,
        success: function (response) {
          self.parseMasterHits(response);
          self.log(self.promises);
        },
        error: function (err) {
          console.log(err);
          self.addAlert("danger", "Search failed");
        },
      });

      this.log(this.promises);
    },
    parseMasterHits: function (data) {
      /*
          {
            aliLen: 183
            identAA: 118
            identity: 64.48
            queryCov: 74.0890688259109
            queryEnd: 247
            queryStart: 65
            score: "3.000e-85"
            simAA: 163
            similarity: 89.07
            templateKey: "1kfu_S"
            }
          */
      if (data.length === 0) {
        // Got an empty result set
        this.addAlert("warning", "No matches found for the query");
        return;
      }

      //presort by seq.id
      let compare = function (a, b) {
        return parseFloat(a.score) > parseFloat(b.score) ? 1 : -1;
      };
      data = data.sort(compare);

      const self = this;
      const d3 = window.d3;

      const colors = d3
        .scaleOrdinal()
        .domain(data.map((d) => d.templateKey))
        .range(
          d3
            .quantize((t) => d3.interpolateSpectral(t * 0.9 + 0.1), data.length)
            .reverse()
        );

      const getColor = function (i) {
        // console.log(colors(i));
        return colors(i);
      };

      data.forEach((match, i) => {
        const p = match.templateKey.split("_");
        const hit = {
          masterID: p[0] + p[1],
          pdbId: p[0],
          chain: p[1],
          score: match.score,
          ident: match.identity,
          aliLen: match.aliLen,
          queryCov: match.queryCov,
          queryEnd: match.queryEnd,
          queryStart: match.queryStart,
          rmsd: null,
          size: null,
          masterDbID: "",
          clusterDbId: "",
          clusterName: "",
          representatives: [],
          color: getColor(i),
          idx: i,
        };
        self.hits.push(hit);

        // load additional cluster data
        self.getClusterData(hit);
      });
    },
    getClusterData: function (hit) {
      const self = this;

      window.jQuery.ajax({
        type: "GET",
        async: true,
        // global: false,
        url:
          this.$dataService.PDBFLEX +
          "/php/pdbChainGetCluster.php?pdb=" +
          hit.pdbId +
          "&chain=" +
          hit.chain,

        success: function (response) {
          // {
          //   "pdbID": "2ekc",
          //   "chainID": "B",
          //   "clusterID": "6835",
          //   "masterID": "16653",
          //   "queryPDB": "2ekc",
          //   "queryChain": "B"
          // }
          // self.log(response);

          if (response.message) {
            // cluster not found
            self.log(response.message);
            self.addAlert(
              "danger",
              `Cluster not found ${hit.pdbId}_${hit.chain}`
            );
            hit.size = "-"; // show instead of spinner
            hit.rmsd = "-";
            return;
          }

          hit.masterDbID = response.masterID;
          hit.clusterDbId = response.clusterID;
          hit.clusterName = response.pdbID + response.chainID;

          self.getClusterStatistics(hit);
          self.getClusterRepresentatives(hit);
        },
        error: function (err) {
          self.log(err);
          hit.size = "-"; // show instead of spinner
          hit.rmsd = "-";
          self.addAlert(
            "danger",
            `Cannot get details for cluster ${hit.pdbId}_${hit.chain}`
          );
        },
      });
    },
    getClusterRepresentatives(hit) {
      const self = this;

      window.jQuery.ajax({
        type: "GET",
        async: true,
        url:
          this.$dataService.PDBFLEX +
          "/fsn-data/fullClusters/" +
          hit.clusterName,
        success: function (response) {
          const data = JSON.parse(response);

          // gets list of subclusters and members of the cubcluster:
          // {
          //   "1a5sA": [],
          //   "1kfjA": [ "3pr2A", "3pr2A", "3pr2A" ],
          //   "6o1hA": []
          // }

          for (var subClusterID in data) {
            // timeout for #18
            // setTimeout(
            let members = data[subClusterID];
            // members.unshift(subClusterID); // no longer needed
            self.getSubclusterData(subClusterID, members, hit);
            // , 500);
            hit.size++;
          }
        },
        error: function (err) {
          self.log(err);
          hit.size = "-"; // show instead of spinner
          self.addAlert(
            "danger",
            `Cannot get representatives for cluster ${hit.pdbId}_${hit.chain}`
          );
        },
      });
    },
    getSubclusterData: function (subClusterID, members, hit) {
      const self = this;
      const pdbId = self.splitPDB(subClusterID);

      const url =
        self.$dataService.PDBFLEX +
        "/php/getPDBInfo.php?pdb=" +
        pdbId[0] +
        "&chain=" +
        pdbId[1];
      // console.log(url);

      window.jQuery.ajax({
        type: "GET",
        async: true,
        url: url,
        success: function (data) {
          // console.log(data);

          let item = {
            name: subClusterID,
            pdb: pdbId[0],
            chain: pdbId[1],
            imgs: [],
            selected: false,
            modelUrl: null,
            modelingStatus: "none",
            modelingMsg: "",
            names: data.proteinNames,
            description: data.description,
            isComplex: data.isComplex === "1" ? true : false,
            length: data.length,
            ligands: data.ligands || [],
            organism: data.organism,
            uniprotId: data.uniprotId,
            members: members,
            master: {
              // backreference
              idx: hit.idx,
              color: hit.color,
              label: hit.masterID,
            },
          };
          hit.representatives.push(item);
        },
        error: function (err) {
          self.log(err);
          self.addAlert(
            "danger",
            `Cannot get data for subcluster ${subClusterID}`
          );
        },
      });
    },
    getClusterStatistics: function (cluster) {
      const self = this;
      window.jQuery.ajax({
        type: "GET",
        async: true,
        url:
          this.$dataService.PDBFLEX +
          "fsn-data/seqres.cl.covrms_ana/" +
          cluster.clusterName,

        success: function (response) {
          // console.log(response);
          const lines = response.split("\n");
          lines.forEach((l) => {
            if (l.startsWith("Maximum C-alpha RMSD:")) {
              const parts = l
                .replace("Maximum C-alpha RMSD:", "")
                .trim()
                .split(" ");
              if (parts.length > 0) {
                cluster.rmsd = parseFloat(parts[0].trim());
              }
            }
          });
        },
        error: function (err) {
          self.log(err);
          cluster.rmsd = "-";
          self.addAlert(
            "danger",
            `Cannot get stats for cluster ${cluster.clusterName}`
          );
        },
      });
    },
    selectInitial: function (count) {
      // preselect 'count' structure with max sequence similarity
      // hits are sorted in parseMasterHits()
      let selectionCount = 0;
      this.hits.forEach((h) => {
        h.representatives.forEach((r) => {
          if (selectionCount < count) {
            r.selected = true;
            selectionCount++;
          }
        });
      });
    },
    runDemo: function () {
      let intro = introJs();
      intro.setOptions({
        steps: [
          // {
          //   element: "#helpSection",
          //   intro: "Click on section header to view help for this page"
          // },

          {
            element: "#searchDesc",
            intro: "Information about search query",
          },
          {
            element: "#analysisSection",
            scrollTo: "tooltip",
            intro:
              "Analysis cart. Click on header to collapse or expand this section. If cart is currently empty select structures from the result table below to see available tools and re-run demo.",
          },
          {
            element: "#cartContentSection",
            intro:
              "List of currently selected structures. Structures are color-coded by cluster. After initial search some structures are <b>randomly</b> selected.",
            position: "right",
          },
          {
            element: "#matrixSection",
            intro:
              "Comparison matrix. Select values to display on matrix. Click on any cell to view pairwise structure comparison.",
            position: "right",
          },
          {
            element: "#pairwiseSection",
            intro:
              "Pairwise comparison. Use buttons to switch between different views.",
            position: "left",
          },
          {
            element: "#resultsHeaderSection",
            intro: "Results table. Click on column header to sort.",
            position: "top",
          },
          {
            element: document.querySelectorAll(
              ".resultsTable tbody > tr:first-child"
            )[0],
            intro: "Each table row repsesents cluster match.",
            position: "top",
          },
          {
            element: document.querySelectorAll(
              ".resultsTable tbody > tr:first-child .pdbinfo-card:first-child"
            )[0],
            intro:
              "Subclusters representatives are shown for each cluster. Use checkbox to add structure to template cart. Modelling button will run modelling using selected template. Click on (i) icon to view more information about template.",
            position: "left",
          },
        ].filter(function (obj) {
          return window.jQuery(obj.element).length;
        }),
      });
      const self = this;
      intro.start().oncomplete(function () {
        self.$parent.isDemoRunning = false;
      });
    },
  },
};
</script>

<style scoped>
.fixed-top-2 {
  margin-top: 56px;
}
</style>